import { cva, type VariantProps } from 'class-variance-authority'
import type { ChildColor } from '@/lib/colors'

export { default as Button } from './Button.vue'

// Tailles uniquement (hauteurs fixes). Les couleurs sont gérées par
// getColorClasses() dans Button.vue (tokens du thème, pas Tailwind brut).
export const buttonVariants = cva(
  'inline-flex items-center rounded-xl font-semibold whitespace-nowrap transition-all active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none outline-none focus-visible:ring-2 focus-visible:ring-line-strong [&_svg]:shrink-0',
  {
    variants: {
      size: {
        xs: 'h-8 px-3 text-xs gap-1.5',
        sm: 'h-10 px-3.5 text-sm gap-1.5',
        md: 'h-12 px-4 text-base gap-2',
        lg: 'h-14 px-6 text-lg gap-2',
        xl: 'h-16 px-6 text-xl gap-2.5',
        '2xl': 'h-[72px] px-7 text-2xl gap-3',
        '3xl': 'h-20 px-8 text-3xl gap-3',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
export type ButtonSize = NonNullable<ButtonVariants['size']>
export type ButtonColor = ChildColor | 'primary' | 'light' | 'night' | 'premium' | 'danger'
export type ButtonColorVariant = 'solid' | 'outline' | 'soft' | 'dashed' | 'clear'
